import axios from "axios";
import { authenticatedApiConfig } from "./BaseApiService";
export class StatsService {
    constructor(authenticationProvider, environment) {
        this.authenticationProvider = authenticationProvider;
        this.environment = environment;
    }
    async getStatsCurrent() {
        const response = await axios.get(`${this.environment.API_BASE_URL}/stats/current`, await authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async getStatsTimeline() {
        const response = await axios.get(`${this.environment.API_BASE_URL}/stats/timeline`, await authenticatedApiConfig(this.authenticationProvider));
        response.data.forEach((timelineStat) => (timelineStat.endOfWeek = new Date(Date.parse(timelineStat.endOfWeek))));
        return response.data;
    }
    async getStatsBreakdown() {
        const response = await axios.get(`${this.environment.API_BASE_URL}/stats/breakdown`, await authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async getStatsCurrentForOrganization(organizationId) {
        const response = await axios.get(`${this.environment.API_BASE_URL}/organizations/${organizationId}/stats/current`, await authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async getStatsTimelineForOrganization(organizationId) {
        const response = await axios.get(`${this.environment.API_BASE_URL}/organizations/${organizationId}/stats/timeline`, await authenticatedApiConfig(this.authenticationProvider));
        response.data.forEach((timelineStat) => (timelineStat.endOfWeek = new Date(Date.parse(timelineStat.endOfWeek))));
        return response.data;
    }
    async getStatsBreakdownForOrganization(organizationId) {
        const response = await axios.get(`${this.environment.API_BASE_URL}/organizations/${organizationId}/stats/breakdown`, await authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async getStatsOverviewTimelineForOrganization(organizationId, interval, limit) {
        let url = `${this.environment.API_BASE_URL}/organizations/${organizationId}/stats/overview/timeline`;
        const response = await axios.get(url, await authenticatedApiConfig(this.authenticationProvider, { interval, limit }));
        return response.data;
    }
    async getStatsCurrentForStudy(organizationId, studyId) {
        const response = await axios.get(`${this.environment.API_BASE_URL}/organizations/${organizationId}/studies/${studyId}/stats/current`, await authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async getStatsCurrentForPatient(organizationId, patientId) {
        const response = await axios.get(`${this.environment.API_BASE_URL}/patients/${patientId}/stats/current`, await authenticatedApiConfig(this.authenticationProvider, { organizationId }));
        return response.data;
    }
}
